var Button = document.getElementsByClassName('js-btn-scroll-top')[0];

document.onscroll = function() {

  if (window.scrollY >= 500) { // To Show Button
    Button.style.opacity = "1";
    Button.style.cursor = "pointer";
    Button.style.display = "block";
  } else {

     Button.style.opacity = "0";
     Button.style.display = "none";
  }


   Button.onclick = function () { // When Click on the buttom Go To Up

    var Smoothy = setInterval(function(){
        window.scrollTo(0,window.scrollY - 100)
      if (window.scrollY <= 0)
        clearInterval(Smoothy)

    }, 20);

}};
